"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const get_1 = __importDefault(require("lodash/get"));
const formatNumber_1 = require("../../../utility/formatNumber");
function CouplingColumn({ row, onHover, format }) {
    const result = (0, get_1.default)(row, 'tableMetaInfo.signal.js');
    return ((0, jsx_runtime_1.jsx)("td", { ...onHover, children: result
            ?.map((coupling) => !Number.isNaN(Number(coupling.coupling))
            ? (0, formatNumber_1.formatNumber)(coupling.coupling, format)
            : '')
            .join(',') }));
}
exports.default = CouplingColumn;
